<template>
    <div class='basic-wrap'>
        <h2>基本信息资料</h2>
        <div class="basic-top">
<!--            <div class="flex">-->
<!--                <p>绑定手机号</p>-->
<!--                <p>{{ mobile }}</p>-->
<!--                <el-button size="mini" round type="primary" @click="showDialogMobile">修改</el-button>-->
<!--            </div>-->
            <div class="flex">
                <p>登录密码</p>
                <p>***********</p>
                <el-button size="mini" round type="primary" @click="showPassword">修改</el-button>
            </div>
            <div class="flex">
                <p>实名认证状态</p>
                <p v-if="!idcard">您的实名认证未提交审核，使用功能可能会受到影响</p>
                <el-button size="mini" round type="primary" @click="showVerified">{{ idcard ? '已认证' : '立即认证' }}</el-button>
            </div>
        </div>
        <div class="basic-bottom">
            <div class="flex flex-row-between">
                <p>企业/事业单位/社会组织认证信息</p>
                <el-button type="primary" size="mini" @click="goAttestation">认领新企业\社会组织\个体商户</el-button>
            </div>
            <ul class="basic-table">
                <li class="flex basic-header">
                    <p>序号</p>
                    <p>企业/事业单位/社会组织名称</p>
                    <p>代码</p>
                    <p>认证材料提交时间</p>
                    <p>认证状态</p>
                </li>
                <template v-if="list.length">
                    <li v-for="(item, index) in list" :key="item.id">
                        <router-link class="flex" :to="`/company?number=${item.number}`" target="_blank">
                            <p>{{ index + 1 }}</p>
                            <p>{{ item.name }}</p>
                            <p>{{ item.number }}</p>
                            <p>{{ item.creatortime }}</p>
                            <p>{{ formateStatus(item.enabledmark) }}</p>
                        </router-link>
                    </li>
                </template>
                <empty v-else />
            </ul>
            <div class="flex flex-row-end pagination-wrap" v-if="list.length">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="current" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

        <dialog-mobile ref="dialogMobileRef" />
        <dialog-password ref="dialogPwRef" />
        <dialog-verified ref="dialogVerifiedRef" />
    </div>
</template>

<script>
import empty from '@/components/empty'

import dialogMobile from './dialog-mobile.vue'
import dialogPassword from './dialog-pw.vue'
import dialogVerified from './dialog-verified.vue'

import { enterpriseClaimPage, certificationInfo } from '@/api';

export default {
    components: {
        empty,
        dialogMobile,
        dialogPassword,
        dialogVerified
    },
    data() {
        return {
            list: [],
            user: {},
            total: 0,
            pageSize: 15,
            current: 1,
            idcard: '' //是否实名，有值为true
        }
    },
    created() {
        const { path } = this.$route;

        this.$emit('userEmit', path)
    },
    mounted() {
        this.getList();
        this.queryCertificationInfo()
    },
    methods: {
        handleCurrentChange(e) {
            this.getList(e)
        },
        getList(page = 1) {
            enterpriseClaimPage({ current: page }).then(res => {
                const { records, per_page, total, current } = res;
                this.$set(this, 'list', records);
                this.$set(this, 'current', current);
                this.$set(this, 'total', total);
                this.$set(this, 'pageSize', per_page);
            })
        },
        formateStatus(status) {
            // 0=已提交,1=已通过,2=未通过
            switch (+status) {
                case 0:
                    return '已提交';
                case 1:
                    return '已通过';
                case 2:
                    return '未通过';
                default:
                    return '';
            }
        },
        resetHandler() {
            this.$set(this, 'list', []);
            this.$set(this, 'total', 0);
            this.$set(this, 'pageSize', 15);
        },
        showDialogMobile() {
            this.$refs['dialogMobileRef'].show('19806221909')
        },
        showPassword() {
            this.$refs['dialogPwRef'].show()
        },
        showVerified() {
            if(this.idcard) return;

            this.$refs['dialogVerifiedRef'].show()
        },
        goAttestation() {
            this.$router.push({ name: 'attestation' })
        },

        queryCertificationInfo() {
            certificationInfo().then(res => {
                const { idcard } = res;
                this.$set(this, 'idcard', idcard)
            })
        }
    },
    computed: {
        mobile({ $store }) {
            return ($store.state.userInfo || {}).mobile;
        }
    },
    watch: {},
}
</script>
<style lang='scss' scoped>
.basic-wrap {
    padding: 22px 18px;
    text-align: left;

    &>h2 {
        color: $red;
    }

    .el-button {
        background-color: $red;
        border-color: $red;
    }

    &>.basic-top {
        border-bottom: 1px solid #e3d7ea;
        padding: 18px 32px;

        &>.flex {
            padding: 15px 0;

            &>p {
                &:first-of-type {
                    widp: 100px;
                    text-align: right;
                    margin-right: 20px;
                }

                &:np-child(2) {
                    font-size: 13px;
                    color: #202020;
                }
            }

            &>.el-button {
                margin-left: 20px;
            }
        }
    }

    &>.basic-bottom {
        padding: 18px 32px;

        &>.basic-table {
            width: 100%;
            margin-top: 15px;

            &>.basic-header {
                font-size: 16px;
                color: #040404;
                border-bottom: 1px solid #e3d7ea;
                background-color: #f4f4f4;
            }

            &>li {
                line-height: 48px;
                height: 48px;

                & p {
                    flex-shrink: 0;
                    flex-basis: 70px;
                    text-align: center;

                    &:nth-child(2) {
                        flex-basis: 420px;
                    }

                    &:nth-child(3) {
                        flex-basis: 200px;
                    }

                    &:nth-child(4) {
                        flex-basis: 180px;
                    }

                    &:last-child {
                        flex-basis: 130px;
                    }
                }
            }
        }
    }
}
</style>
